export const INPUT_FILE_TOKEN = "{inputFile}";
